export function evaluatePasswordStrength(password: string) {
    const _password = password.trim();
    let maxPasswordStrength = 4;
    if (_password.length < 12) {
        maxPasswordStrength = 1;
    }
    const testResults = [
        /\d/.test(_password),
        /[a-z]/.test(_password),
        /[A-Z]/.test(_password),
        /[!@#$%^&*(),.?":{}|<>;'"]/.test(_password),
    ];
    const score = testResults.reduce((sum, curr) => (sum + (curr ? 1 : 0)), 0);
    return Math.min(score, maxPasswordStrength);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/utils/passwordStrength.ts